/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// Insert any custom theme js here...

// Desktop megamenu
function initDesktopMegamenu() {
    let megamenu_buttons = document.querySelectorAll('[megamenu-button]');
    let overlay = document.querySelector('.plug-header__megamenu-container-overlay');
    let megamenu_container = document.querySelector('.plug-header__megamenu-container');
    let body_element = document.querySelector('body');
    let megamenu_contents = document.querySelectorAll('.plug-header__megamenu-content');
    megamenu_contents.forEach((megamenu) => {
        let all_links = megamenu.querySelectorAll('a,button');
        if (all_links.length > 0) {
            all_links[all_links.length - 1].addEventListener('keydown', (event)=> {
                if (event.key == "Tab") {
                    console.log(all_links)
                    event.preventDefault();
                    all_links[0].focus();
                }
            })
        }
        
    })
    if (overlay != undefined) {
        overlay.addEventListener('click', ()=> {
            megamenu_buttons.forEach((button) => {
                button.classList.remove('active');
                megamenu_container.classList.remove('active');
                body_element.classList.remove('megamenu-open')
            });
        })
    }

    megamenu_buttons.forEach((button) => {
        button.addEventListener('click', toggleShow);
        button.addEventListener('keydown', toggleShow)
    });
}

function toggleShow(event) {
    if  (event.key != undefined && event.key !== "Enter") {
        return
    }
    let megamenu_container = document.querySelector('.plug-header__megamenu-container');
    let body_element = document.querySelector('body');
    let all_megamenu_bottons = document.querySelectorAll('[megamenu-button]');
    let all_menu_buttons = document.querySelectorAll('.primary-nav__item.has_link');
    
    all_menu_buttons.forEach((megamenu) => {
        if (megamenu != event.currentTarget) {
            megamenu.classList.remove('current-selected');
        } else {
            event.currentTarget.classList.add('current-selected');
        }
    })
    all_megamenu_bottons.forEach((megamenu) => {
        if (megamenu != event.currentTarget) {
            megamenu.classList.remove('active');
        } else {
            event.currentTarget.classList.toggle('active');
        }
    })
    if (Array.from(event.currentTarget.classList).includes('active')) {
        megamenu_container.classList.add('active');
        body_element.classList.add('megamenu-open')
    } else {
        megamenu_container.classList.remove('active');
        body_element.classList.remove('megamenu-open')
    }
    
    showMegamenu(event)
}

function showMegamenu(event) {
    let megamenu_contents = document.querySelectorAll('.plug-header__megamenu-content');
    let target = event.currentTarget.getAttribute('target_menu');
    target = document.querySelector(`#${target}`);
    megamenu_contents.forEach((megamenu) => {
        if (megamenu == target) {
            console.log('found')
            megamenu.classList.add('active');
            let btn = megamenu.querySelector('.plug-btn');
            if (btn != undefined) {
                btn.focus({focusVisible: true});
            } else {
                let first_link = megamenu.querySelector('a');
                first_link.focus({focusVisible: true});
            }
            let all_interactable =  megamenu.querySelectorAll('[tabindex="-1"]');
            all_interactable.forEach((interactable)=> {
                interactable.setAttribute('tabindex', 0)
            })
        } else {
            megamenu.classList.remove('active');
            let all_interactable =  megamenu.querySelectorAll('[tabindex="0"]');
            all_interactable.forEach((interactable)=> {
                interactable.setAttribute('tabindex', -1)
            })
        }
    })
}

function showNav() {
    var lastScrollTop = 0;
    var header_height = $('.plug-header__container').height() + 44;
    $(window).scroll(function(event){
        if (!$('body').hasClass('.drawer--open')) {
            var st = $(this).scrollTop();
            if (st < lastScrollTop){
                $('#shopify-section-plug-header').removeClass('hide_nav');
            } else {
                if (st > (header_height)) {
                    if (!$('#shopify-section-plug-header').hasClass('hide_nav')) {
                        $('#shopify-section-plug-header').addClass('hiding_nav');
                        setTimeout(function(){
                            $('#shopify-section-plug-header').removeClass('hiding_nav');
                            $('#shopify-section-plug-header').addClass('hide_nav');
                        }, 300)
                    } else {
                        $('#shopify-section-plug-header').removeClass('hiding_nav');
                    }
                }
            }
            if (st == 0) {
                $('.back-to-top').hide();
                $('#shopify-section-plug-header').addClass('top_page');
            } else {
                $('.back-to-top').removeAttr('style');
                $('#shopify-section-plug-header').removeClass('top_page');
            }
            lastScrollTop = st;
        }
    });
}
function openDrawer() {
    let all_buttons = document.querySelectorAll('.primary-nav__item.has_link:not([megamenu-button]), .header-drawer__toggler');
    all_buttons.forEach(function(button) {
        button.addEventListener('click', open);
        button.addEventListener('keydown', open)
    })
}

function open(event) {
    console.log(event.key)
    if (event.key != undefined && event.key === "Enter") {
        event.preventDefault();
    }
    if  (event.key != undefined && event.key !== "Enter") {
        return
    }

    $('html, body').addClass("drawer--open");
    var target = $(this).attr('target');
    var target_element = $(`.header-drawer__main-link.has_link[category="${target}"]`);
    if (target != undefined) {
        let drawer_menu  = document.querySelector('.header-drawer__container');
        let all_interactable =  drawer_menu.querySelectorAll('[tabindex="-1"]');
        all_interactable.forEach((interactable)=> {
            interactable.setAttribute('tabindex', 0)
        })

        let all_buttons = document.querySelectorAll('.primary-nav__item.has_link');
        all_buttons.forEach((button) => {
            button.classList.remove('current-selected');
        });
        $(this).addClass('current-selected')

        $('.header-drawer__main-link.has_link').each(function(){
            $(this).addClass('collapsed');
            $(this).siblings('.header-drawer__links').addClass('collapsed');
            $(this).attr('aria-expanded', false);
            $(this).siblings('.header-drawer__links').attr('aria-hidden', true);
        })
        target_element.removeClass('collapsed');
        target_element.siblings('.header-drawer__links').removeClass('collapsed');
        target_element.attr('aria-expanded', true);
        target_element.siblings('.header-drawer__links').attr('aria-hidden', false)
        let target_element_sublinks = target_element.siblings('.header-drawer__links').find('.header-drawer__child-link');
        target_element_sublinks.each(function() {
            $(this).removeAttr('aria-hidden');
            $(this).attr('tabindex', '0');
        })
        var sub_items = $(`.header-drawer__main-link.has_link[category="${target}"]`).siblings('.header-drawer__links').find('.header-drawer__link-container').children();
        target_element.focus();
        target_element.focus({focusVisible: true});
    }
}
function closeDrawer() {
    let all_buttons = document.querySelectorAll('.header-drawer__overlay, .header-drawer__close');
    all_buttons.forEach(function(button) {
        button.addEventListener('click', close);
        button.addEventListener('keydown', close)
    })
    document.addEventListener('keydown', closeESC)
}
function close(event) {
    if  (event.key != undefined && event.key !== "Enter") {
        return
    }
    $('html, body').removeClass("drawer--open");
    let drawer_menu  = document.querySelector('.header-drawer__container');
    let all_interactable =  drawer_menu.querySelectorAll('[tabindex="0"]');
    all_interactable.forEach((interactable)=> {
        interactable.setAttribute('tabindex', -1)
    })
}
function closeESC(event) {
    if  (event.key != undefined && event.key !== "Escape") {
        return
    }
    let megamenu_container = document.querySelector('.plug-header__megamenu-container');
    let megamenu_buttons = document.querySelectorAll('[megamenu-button]');
    let last_selected = document.querySelector('.current-selected');
    $('html, body').removeClass("drawer--open");
    megamenu_container.classList.remove('active');
    megamenu_buttons.forEach((button) => {
        button.classList.remove('active');
    });
    if (last_selected != undefined) {
        last_selected.focus({focusVisible: true});
    }
}
function toggleAccordion() {
    $('.header-drawer__item.has_link').on('click', accordionToggle);
    $('.header-drawer__item.has_link').on('keydown', accordionToggle);
    $('.plug-footer__toggle').on('click', function() {
        $('.plug-footer__newsletter-container').addClass('show_form');
    });
    $('.plug-footer__label').each(function(){
        var content = $(this).siblings('.plug-footer__links').find('.plug-footer__links-wrapper').first();
        var  height = content.outerHeight();
        $(this).siblings('.plug-footer__links').css('max-height', `${height}px`);
    })
    $('.plug-footer__label').on('click', function() {
        var content = $(this).siblings('.plug-footer__links').find('.plug-footer__links-wrapper').first();
        var  height = content.outerHeight();
        var state = $(this).attr('aria-expanded');
        if (state == "false") {
            $(this).attr('aria-expanded', true);
        } else {
            $(this).attr('aria-expanded', false);
        }

        $(this).siblings('.plug-footer__links').css('max-height', `${height}px`);
        $(this).toggleClass('collapsed');
        $(this).siblings('.plug-footer__links').toggleClass('collapsed');
    });
    $(window).on('load resize orientationchange', function() {
        $('.plug-footer__label').each(function() {
            var content = $(this).siblings('.plug-footer__links').find('.plug-footer__links-wrapper').first();
            var  height = content.outerHeight();
            $(this).siblings('.plug-footer__links').css('max-height', `${height}px`);
        })
    });
};

function accordionToggle(event) {
    console.log("CLICK")
    if  (event.key != undefined && event.key !== "Enter") {
        return
    }
    var content = $(this).siblings('.header-drawer__links').find('.header-drawer__link-container').first();
    var height = content.outerHeight();
    var parent_container = $(this).parents('.header-drawer__links');
    let sublink_container = $(this).siblings('.header-drawer__links');
    let children_class = ".header-drawer__grandchild-link";
    if ($(this).hasClass('.header-drawer__main-link')) {
        children_class = ".header-drawer__child-link"
    }
    console.log("TEST")
    console.log(parent_container);
    console.log(content)
    if (parent_container.length > 0) {
        var parent_height = $(this).closest('.header-drawer__links').outerHeight();
        $(this).closest('.header-drawer__links').css('max-height', `${height + parent_height + 20}px`);
    }
    $(this).siblings('.header-drawer__links').css('max-height', `${height + 60}px`);
    $(this).toggleClass('collapsed');
    sublink_container.toggleClass('collapsed');
    if ($(this).hasClass('collapsed')) {
        $(this).attr('aria-expanded', false);
    }  else {
        $(this).attr('aria-expanded', true);
    }
    if (sublink_container.hasClass('collapsed')) {
        sublink_container.attr('aria-hidden', true);
        sublink_container.find('').each(function() {
            $(this).attr('aria-hidden', true);
            $(this).attr('tabindex', '-1');
        })
    }  else {
        sublink_container.removeAttr('aria-hidden'  );
        sublink_container.find('.header-drawer__child-link').each(function() {
            $(this).removeAttr('aria-hidden');
            $(this).removeAttr('tabindex');
        })
    }
}
function initbacktotop() {
    $('.back-to-top').click(function(){
        $("html, body").animate({ scrollTop: 0 });
    })
}

function initProductCardSlider() {
    const elems = document.querySelectorAll('[data-plug-slider]');
    elems.forEach((elem) => {
        let flkty = new Flickity( elem, {
            cellAlign: 'center',
            pageDots: false,
            prevNextButtons: false,
            watchCSS: true,
            contain: true,
            imagesLoaded: true,
            groupCells: true
        });
        

        const checkFlkty = () => {
            if ($(elem).hasClass('flickity-enabled')) {
                console.log('FLICKITY INITIATED');
            } else {
                console.log(elem);
                // location.reload();
                if($(elem).attr('mobile')) {
                    console.log('mobile only');
                } else {
                    location.reload();
                }
            }
        }

        function flickityInitiated() {
            checkFlkty();
            const $prev = $(elem).siblings('.plug-slider__navigation').find('.plug-nav--prev');
            const $next = $(elem).siblings('.plug-slider__navigation').find('.plug-nav--next');
            flkty.on('dragStart', () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none") );
            flkty.on('dragEnd', () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all") );
            function checkButtons() {
                if (flkty.selectedIndex == 0) {
                    $prev.attr('aria-disabled', true);
                } else if (flkty.selectedIndex == flkty.slides.length - 1) {
                    $next.attr('aria-disabled', true);
                } else {
                    $prev.attr('aria-disabled', false);
                    $next.attr('aria-disabled', false);
                }
            }
            flkty.on( 'change', function( index ) {
                checkButtons()
            });
            if (flkty.slides.length > 1) {
                checkButtons();
                $prev.on( 'click', function() {
                    flkty.previous();
                    checkButtons();
                });
                $next.on( 'click', function() {
                    flkty.next();
                    checkButtons();
                });
            } else {
                $prev.hide();
                $next.hide();
            }
        }
        const mobileOnly = $(elem).attr('mobile');
        if (window.innerWidth > 769 && mobileOnly) {

        } else {
            flickityInitiated();
        }
        window.addEventListener("resize", (event) => {
            
            if (window.innerWidth > 769 && mobileOnly) {

            } else {
                if (!$(elem).hasClass('flickity-enabled')) {
                    flickityInitiated();
                }
            }
        });
    });

}
function initKeen(root = document) {
    function navigation(slider) {
        let wrapper, dots, arrowLeft, arrowRight, sectionWrapper, mobileArrowLeft, mobileArrowRight
        const movePrev = () => slider.prev()
        const moveNext = () => slider.next()
      
        function markup(remove) {
          wrapperMarkup(remove)
          dotMarkup(remove)
          arrowMarkup(remove)
        }
      
        function removeElement(elment) {
          elment.parentNode.removeChild(elment)
        }
        function createDiv(className) {
          var div = document.createElement("div")
          var classNames = className.split(" ")
          classNames.forEach((name) => div.classList.add(name))
          return div
        }
      
        function arrowMarkup(remove) {
            if (remove) {
                mobileArrowLeft.removeEventListener("click", movePrev)
                mobileArrowRight.removeEventListener("click", moveNext)
                removeElement(arrowLeft)
                removeElement(arrowRight)
                return
            }
            arrowLeft = createDiv("arrow desktop-only arrow--left")
            arrowLeft.setAttribute('tabindex', "0");
            arrowLeft.setAttribute('role', "button");
            arrowLeft.setAttribute('aria-label', "Previous slide");
            arrowLeft.addEventListener("click", () => slider.prev())
            arrowRight = createDiv("arrow desktop-only arrow--right")
            arrowRight.addEventListener("click", () => slider.next())
            arrowRight.setAttribute('role', "button");
            arrowRight.setAttribute('aria-label', "Next slide");
            arrowRight.setAttribute('tabindex', "0");
            wrapper.appendChild(arrowLeft)
            wrapper.appendChild(arrowRight)

          //Add mobile arrows
          sectionWrapper = wrapper.parentNode;
          mobileArrowLeft = sectionWrapper.querySelector('.plug-nav--prev');
          mobileArrowRight = sectionWrapper.querySelector('.plug-nav--next');
          mobileArrowLeft.addEventListener("click", movePrev);
          mobileArrowRight.addEventListener("click", moveNext)
        }
      
        function wrapperMarkup(remove) {
          if (remove) {
            var parent = wrapper.parentNode
            while (wrapper.firstChild)
              parent.insertBefore(wrapper.firstChild, wrapper)
            removeElement(wrapper)
            return
          }
          wrapper = createDiv("navigation-wrapper")
          slider.container.parentNode.appendChild(wrapper)
          wrapper.appendChild(slider.container)
        }
      
        function dotMarkup(remove) {
          if (remove) {
            removeElement(dots)
            return
          }
          dots = createDiv("dots")
          slider.track.details.slides.forEach((_e, idx) => {
            var dot = createDiv("dot")
            dot.addEventListener("click", () => slider.moveToIdx(idx))
            dots.appendChild(dot)
          })
          wrapper.appendChild(dots)
        }
      
        function updateClasses() {
            const details = slider.track.details
            const perView = Number(slider.options.slides.perView) || 1
            const hasOverflow = slider.slides.length > perView && details.maxIdx > details.minIdx
            sectionWrapper.classList.toggle("plug-featured-collection--single-page", !hasOverflow)

            slider.track.details.minIdx === slider.track.details.abs
                ? arrowLeft.classList.add("arrow--disabled")
                : arrowLeft.classList.remove("arrow--disabled")
            slider.track.details.maxIdx === slider.track.details.abs
                ? arrowRight.classList.add("arrow--disabled")
                : arrowRight.classList.remove("arrow--disabled")

            slider.track.details.minIdx === slider.track.details.abs
                ? mobileArrowLeft.setAttribute('aria-disabled', 'true')
                : mobileArrowLeft.setAttribute('aria-disabled', 'false')
            slider.track.details.maxIdx === slider.track.details.abs
                ? mobileArrowRight.setAttribute('aria-disabled', 'true')
                : mobileArrowRight.setAttribute('aria-disabled', 'false')
            
            // slide === 0
                // ? arrowLeft.classList.add("arrow--disabled")
                // : arrowLeft.classList.remove("arrow--disabled")
            // slide === slider.track.details.slides.length - 1
            //     ? arrowRight.classList.add("arrow--disabled")
            //     : arrowRight.classList.remove("arrow--disabled")
        }
      
        slider.on("created", () => {
          markup()
          updateClasses()
        })
        slider.on("optionsChanged", () => {
          console.log(2)
          markup(true)
          markup()
          updateClasses()
        })
        slider.on("slideChanged", () => {
          updateClasses()
        })
        slider.on("updated", () => {
          updateClasses()
        })
        slider.on("destroyed", () => {
          markup(true)
          sectionWrapper.classList.remove("plug-featured-collection--single-page")
        })
      }
      

    const keenSliders = root.querySelectorAll("[plug-keen-slider]");
    for (let i = 0; i < keenSliders.length; i++) {
        const element = keenSliders[i];
        if (element._plugKeenSlider) continue;
        if (!element.querySelector(".keen-slider__slide")) {
            element.parentNode.classList.add("plug-featured-collection--single-page");
            continue;
        }

        const desktopValue = Number(element.dataset.productsPerViewDesktop);
        const mobileValue = Number(element.dataset.productsPerViewMobile);
        const desktopPerView = Number.isFinite(desktopValue) && desktopValue >= 1 && desktopValue <= 6 ? desktopValue : 4;
        const mobilePerView = Number.isFinite(mobileValue) && mobileValue >= 1 && mobileValue <= 3 ? mobileValue : 1.2;

        element._plugKeenSlider = new KeenSlider(element, {
            slides: {
                perView: desktopPerView
            },
            breakpoints: {
                '(max-width: 1024px)': {
                    slides: {
                        perView: Math.min(desktopPerView, 3)
                    },
                },
                '(max-width: 768px)': {
                    slides: {
                        origin: mobilePerView < 2 ? "center" : "auto",
                        perView: mobilePerView
                    },
                },
            }
        }, [navigation]);
    }
}

function accessibility() {
    if ($('#stamped-main-widget').length > 0) {
        let checker = setInterval(function() {
            let rating = $('.summary-rating');
            if (rating.length > 0) {
                rating.each(function() {
                    let aria_label = $(this).find('.summary-rating-bar').attr('aria-label');
                    $(this).attr('role', 'button');
                    $(this).attr('aria-label', aria_label);
                    $(this).attr('tabindex', 0)
                });
                clearInterval(checker);
            }
        }, 100)
    }
}
window.addEventListener("DOMContentLoaded", function() {
    initDesktopMegamenu();
    showNav();
    openDrawer();
    closeDrawer();
    toggleAccordion();
    initbacktotop();
    initProductCardSlider();
    initKeen();
    accessibility();
});

document.addEventListener("shopify:section:load", function(event) {
    initKeen(event.target);
});

document.addEventListener("shopify:section:unload", function(event) {
    event.target.querySelectorAll("[plug-keen-slider]").forEach(function(element) {
        if (element._plugKeenSlider) {
            element._plugKeenSlider.destroy();
            element._plugKeenSlider = null;
        }
    });
});